var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Catalogue max-h-full"},[_c('main-filter-catalogue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }